import {Component} from "@angular/core";

import {AppController} from "../AppController";

@Component({
  selector: "app-organization-not-found-page",
  templateUrl: "./OrganizationNotFoundPage.html",
})
export class OrganizationNotFoundPage {

  public constructor(private readonly _appController: AppController) {}

  public get appController() {
    return this._appController;
  }

}
